module.exports = __webpack_public_path__ + "img/flower_thumb.1104d1ef.jpg";